export const isGroupedDropdownItems = (items) => items.length > 0 && 'items' in items[0];
